import state from './moduloOperationsState';
import mutations from './moduloOperationsMutations';
import * as actions from './moduloOperationsActions';
import * as getters from './moduloOperationsGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
